import * as React from 'react';
import { useApplicationContext } from '../../utils/applicationContext';
import { useSelector } from 'react-redux';
import { selectBuilder, selectProject } from '../../selectors';
import { CountrysideBuildersCallback } from '@cian/frontend-builders-callback-widget';
import { selectUserName, selectUserPhone } from '../../selectors/user';
import { ECallbackWidgetPlacement } from '../../types/callbackWidget';
import { useCallbackAnalytics, useCallbackButtonProps } from './hooks';
import { selectLocationId } from '../../selectors/location';
import { selectIsCallbackButtonEnabled } from '../../selectors/callbackButton';

interface ICallbackContainerProps {
  placement: ECallbackWidgetPlacement;
}

export const CallbackContainer: React.FC<ICallbackContainerProps> = ({ placement }) => {
  const { httpApi, logger } = useApplicationContext();
  const project = useSelector(selectProject);
  const builder = useSelector(selectBuilder);
  const userPhone = useSelector(selectUserPhone);
  const userName = useSelector(selectUserName);
  const regionId = useSelector(selectLocationId);

  const buttonProps = useCallbackButtonProps(placement);
  const { trackCallbackModalOpen, trackCallbackApplicationSubmit } = useCallbackAnalytics(placement);

  const isCallbackFormEnabled = useSelector(selectIsCallbackButtonEnabled);

  /* istanbul ignore next */
  if (!isCallbackFormEnabled) {
    return null;
  }

  return (
    <CountrysideBuildersCallback
      httpApi={httpApi}
      logger={logger}
      companyId={builder.id}
      projectId={project.id}
      buttonProps={buttonProps}
      regionId={regionId}
      phone={userPhone}
      userName={userName}
      onOpen={trackCallbackModalOpen}
      onSubmit={trackCallbackApplicationSubmit}
    />
  );
};
